<template>
  <!-- 引导语类型 -->
  <div
    ref="describe"
    class="guide-language-type"
  >
    <div class="describe">
      <img
        class="robot"
        src="../assets/image/test-robot-photo.png"
        alt=""
      >
      <div>
        <div class="subject-content">
          <div class="subject-content-bg" />
          {{ content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    content: String
  },
  data () {
    return {
      showAnswer: false,
      answerText: '',
      activeAnswer: '',
      isDisabled: false,
      showOptionAnswer: false,
      optionAnswerText: '',
      showEditLastQuestion: false,
      editDisable: true
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created () {
    // if(this.question.answerVos && this.question.answerVos.length === 0) {
    // this.$emit("loadNextQuestion", {
    //   index:this.index,
    //   answerIds: []
    // })
    // }
    // if (this.question.userAnswerVos && this.question.userAnswerVos.length > 0) {
    //   this.isDisabled = true
    //   this.answerText = this.question.userAnswerVos[0].content
    //   this.activeAnswer = this.question.userAnswerVos[0].id
    //   if (this.question.userAnswerVos[0].optionAnswer) {
    //     this.optionAnswerText = this.question.userAnswerVos[0].optionAnswer
    //     this.showOptionAnswer = true
    //   }
    //   if (this.answerText) {
    //     this.showAnswer = true
    //   }
    // }
  },
  methods: {
    selectAnswer (answerItem) {
      if (this.isDisabled) {
        return false
      }
      this.activeAnswer = answerItem.id
      this.answerText = answerItem.content
      this.showAnswer = true
      this.$nextTick(() => {
        this.$parent.onScrollBottom()
        if (answerItem.optionAnswer) {
          this.optionAnswerText = answerItem.optionAnswer
          this.showOptionAnswer = true
          this.$nextTick(() => {
            this.$parent.onScrollBottom()
            this.isDisabled = true
            let answerIds = []
            answerIds.push(answerItem.id)
            this.showEditLastQuestion = true

            this.$emit("loadNextQuestion", {
              index: this.index,
              answerIds: answerIds
            })
          })
          return
        }
        this.isDisabled = true
        let answerIds = []
        answerIds.push(answerItem.id)
        this.showEditLastQuestion = true
        this.$emit("loadNextQuestion", {
          index: this.index,
          answerIds: answerIds
        })
      })
    },
    // 修改上一题
    modilyLastQuestion () {
      this.activeAnswer = ""
      this.showEditLastQuestion = false
      this.showOptionAnswer = false
      setTimeout(() => {
        if (this.showRobotAnswer) {
          this.$refs.robotAnswerContain.style.left = '-120%'
          this.$refs.robotAnswerContain.style.opacity = '0'
          this.showRobotAnswer = false
        }
        this.$refs.answerContain.style.left = '120%'
        this.$refs.answerContain.style.opacity = '0'
        // this.showEditLastQuestion = false
      }, 0)
      setTimeout(() => {
        this.isDisabled = false
        this.showEditLastQuestion = false
        this.showAnswer = false
      }, 600)
      this.$emit("modifyLastQuestuon", {
        index: this.index,
        answerIds: this.question.questionId,
        dimensionId: this.question.dimensionId
      })
    },
    startMoveAnimation () {
      this.$refs.describe.style.left = '-120%'
      this.$refs.describe.style.opacity = '0'
    }
  }
}
</script>

<style lang="scss" scoped>
.guide-language-type {
  position: relative;
  left: 0;
  opacity: 1;
  transition: left 0.5s, opacity 0.5s;
  .describe,
  .guide-language {
    display: flex;
    margin-top: 30px;
    .robot {
      width: 88px;
      height: 88px;
      border-radius: 50%;
    }
    &:first-child {
      margin-top: 0px;
    }
  }
  .active-multiple-item {
    color: #ffffff;
    background: #00baff;
  }
  .multiple-item:first-child {
    margin-top: 0;
  }
}
</style>
